import React, { useRef, useState } from "react";
import { isEmpty } from "lodash";
import { Pagination as TablePagination } from "@sonder/ui/source/styled/fragments/Table";
import { useSegment } from "analytics/segment";

interface PaginationProps {
  className?: string;
  cursor: string | null;
  hasNextPage: boolean;
  onPrevClick?(cursor: string | null): void;
  onNextClick?(): void;
}
export const Pagination = ({
  className,
  cursor,
  hasNextPage,
  onPrevClick = () => undefined,
  onNextClick = () => undefined,
}: PaginationProps) => {
  const { track } = useSegment();
  const [prevCursors, setPrevCursors] = useState<(string | null)[]>([]);
  const initialCursor = useRef(cursor);

  if (initialCursor.current === cursor && !isEmpty(prevCursors))
    setPrevCursors([] as string[]);

  return (
    <TablePagination
      className={className}
      hasNext={hasNextPage}
      hasPrev={!isEmpty(prevCursors)}
      onNextClick={() => {
        setPrevCursors([...prevCursors, cursor]);
        onNextClick();
        track({
          eventName: "task_list",
          action: "click",
          element: "next_page_button",
        });
      }}
      onPrevClick={() => {
        const lastIndex = prevCursors.length - 1;
        const prevCursor = prevCursors[lastIndex];
        setPrevCursors(prevCursors.slice(0, lastIndex));
        onPrevClick(prevCursor);
        track({
          eventName: "task_list",
          action: "click",
          element: "previous_page_button",
        });
      }}
    />
  );
};
